import { tv } from 'tailwind-variants';

export const mobileElement = 'md-max:hidden';
export const desktopElement = 'md:hidden';

export const styles = tv({
  slots: {
    base: 'relative flex flex-col max-lg:mt-3 max-lg:gap-5 lg:flex-row lg:flex-wrap',
    firstPart:
      'sticky flex h-min w-full flex-col gap-5 max-lg:relative lg:mr-auto lg:w-[calc(100%-90px-450px)] lg:gap-11',
    secondPart:
      'flex h-min flex-col gap-5 max-md:mt-3 max-md:mb-18 lg:w-[450px] lg:gap-12',
    top: '',
    advantages: '',
    banners: ''
  },
  variants: {
    color: {
      primary: 'text-main'
    }
  },
  defaultVariants: {
    color: 'primary'
  }
});
